import { InputType } from '@import/enums/input-type.enum';
import { ColumnType } from '@import/interfaces';

export const PersonalInformationColumnsTypes: ColumnType[] = [
    {
        label: 'Preferred First Name',
        relatedLabels: ['Prefered Given Name', 'First Name (Preferred)'],
        translatableLabel: 'import.columnTypes.preferredFirstName',
        serializeName: 'firstName',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Preferred Last Name',
        relatedLabels: ['Preferred Surname', 'Preferred Maiden Name', 'Last Name (Preferred)'],
        translatableLabel: 'import.columnTypes.preferredLastName',
        serializeName: 'lastName',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Date of Birth',
        relatedLabels: ['Birthday', 'Birth date'],
        translatableLabel: 'import.columnTypes.dateOfBirth',
        serializeName: 'bornOn',
        input: InputType.date,
        required: false,
    },
    {
        label: 'Show birthday as a team event',
        relatedLabels: ['Birthday Visibility'],
        translatableLabel: 'import.columnTypes.showBirthdayAsTeamEvent',
        serializeName: 'isBirthdayPrivate',
        input: InputType.options,
        required: false,
        options: [
            {
                label: 'Yes',
                relatedLabels: ['Yes', 'true'],
                translatableLabel: 'yes',
                value: 0,
            },
            {
                label: 'No',
                relatedLabels: ['No', 'false'],
                translatableLabel: 'no',
                value: 1,
            },
        ],
    },
    {
        label: 'Legal Sex',
        relatedLabels: ['Gender', 'Sex'],
        translatableLabel: 'import.columnTypes.legalSex',
        serializeName: 'legal_sex',
        input: InputType.options,
        options: [
            {
                label: 'M',
                relatedLabels: ['Male', 'Man', 'Men', 'Mister', 'Sir'],
                translatableLabel: 'M',
                value: 'M',
            },
            {
                label: 'F',
                relatedLabels: ['Female', 'Woman', 'Women', 'Lady', 'Maam"', "Ma'am", 'Madams'],
                translatableLabel: 'F',
                value: 'F',
            },
            {
                label: 'X',
                translatableLabel: 'X',
                value: 'X',
            },
            {
                label: 'Prefer Not To Say',
                relatedLabels: ['Other', 'Undisclosed', 'P'],
                translatableLabel: 'P',
                value: 'P',
            },
        ],
        required: false,
    },
    {
        label: 'Genders',
        relatedLabels: ['Genders'],
        translatableLabel: 'import.columnTypes.genders',
        serializeName: 'genders',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Pronouns',
        relatedLabels: ['Pronouns'],
        translatableLabel: 'import.columnTypes.pronouns',
        serializeName: 'pronouns',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Require SIN',
        relatedLabels: ['Require SIN'],
        translatableLabel: 'import.columnTypes.requireSin',
        serializeName: 'isSinRequired',
        input: InputType.boolean,
        required: false,
        options: [
            {
                label: 'Yes',
                relatedLabels: ['Yes', 'true'],
                translatableLabel: 'iyes',
                value: true,
            },
            {
                label: 'No',
                relatedLabels: ['No', 'false'],
                translatableLabel: 'no',
                value: false,
            },
        ],
    },
    {
        label: 'SIN',
        relatedLabels: ['Social Insurance Number'],
        translatableLabel: 'import.columnTypes.sin',
        serializeName: 'sin',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Home Phone',
        translatableLabel: 'import.columnTypes.homePhone',
        serializeName: 'phoneHome',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Mobile Phone',
        translatableLabel: 'import.columnTypes.mobilePhone',
        serializeName: 'phoneMobile',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Work Phone',
        translatableLabel: 'import.columnTypes.workPhone',
        serializeName: 'phoneWork',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Dietary Restriction',
        translatableLabel: 'import.columnTypes.dietaryRestriction',
        serializeName: 'dietaryRestrictions',
        input: InputType.string,
        required: false,
    },
];
